<template>
  <div class="page" v-if="stepFromRoute === 'register'">
    <main class="layout">
      <!-- LEFT -->
      <section class="left">
        <header class="topbar">
          <img class="topbar__logo" src="../assets/images/logo-perindo-new.png" alt="Partai Perindo" />
        </header>

        <div class="formWrap">
          <h1 class="title">Jadi Bagian dari Energi Baru Indonesia</h1>
          <p class="subtitle">Ambil bagian dan ikut buat perubahan</p>

          <form class="form" @submit.prevent="onSubmit">
            <div class="phoneRow">
              <FieldInput
                v-model="phone"
                label="Nomor Handphone"
                placeholder="Masukkan nomor handphone kamu"
                type="numeric"
                :maxlength="13"
                :state="phoneState"
                :message="phoneMessage"
              />
            </div>

            <div class="hint" v-if="phoneState !== 'error'">
              <img src="../assets/icons/info_gray.svg" alt=""/>
              <span>Pastikan nomor aktif untuk dapatkan akses Vision+</span>
            </div>

            <FieldInput
              v-model="password"
              label="Password"
              placeholder="Masukkan password"
              :type="showPassword ? 'text' : 'password'"
              :state="passwordState"
              :message="passwordMessage"
            >
              <template #icon>
                <button
                  class="eye"
                  type="button"
                  :aria-label="showPassword ? 'Sembunyikan password' : 'Tampilkan password'"
                  @click="togglePassword"
                >
                  <img src="../assets/images/icon-pass.png" alt="" />
                </button>
              </template>
              <template #message-icon>
                <img src="../assets/icons/check_circle.svg" alt="" v-if="passwordState === 'success'"/>
              </template>
            </FieldInput>

            <div class="hint" v-if="passwordState === 'default'">
              <img src="../assets/icons/info_gray.svg" alt=""/>
              <span>Minimal 8 karakter dan mengandung huruf besar</span>
            </div>

            <FieldInput
              v-model="confirmPassword"
              label="Ulangi Password"
              placeholder="Masukkan ulang password"
              :type="showConfirmPassword ? 'text' : 'password'"
              :state="confirmState"
              :message="confirmMessage"
            />

            <FieldSelect
              v-model="reference"
              label="Referensi Pendaftaran"
              placeholder="Dari mana anda dapat info soal Perindo?"
              :options="referenceOptions"
              label-key="name"
              value-key="id"
              :searchable="false"
            />

            <FieldInput
              v-if="reference === 5"
              v-model="referenceOther"
              label="Masukkan Referensi"
              placeholder="Referensi anda"
            />

            <button
              class="btn"
              type="submit"
              :disabled="!canSubmit || isLoad"
            >
              <span v-if="!isLoad">Daftar</span>
              <span v-else>Sedang mendaftar...</span>
            </button>

            <p class="signup">
              Sudah punya akun?
              <a href="#" @click.prevent="onLogin">Login</a>
            </p>
          </form>

          <div class="info" v-if="banner">
            <div class="info__icon" aria-hidden="true">
              <img :src="banner?.image_url" alt="vision plus" />
            </div>
            <div class="info__text" v-html="banner?.title" />
          </div>
        </div>

        <footer class="footer">
          <span>Copyright 2025 Partai Perindo</span>
        </footer>
      </section>

      <aside class="right">
        <SideCollage />
      </aside>
    </main>
  </div>
  <OtpSection
    v-else
    :logo-src="otpLogoSrc"
    :otp-icon-src="otpIconSrc"
    :phone="phone || phoneNumber"
    :loading="otpLoading"
    :state="otpState"
    :message="''"
    :type="otpType"
    :valid-until="otpValidUntil"
    @back="backToRegister"
    @submit="verifyOtp"
    @resend="resendOtp"
    @change="onOtpChange"
  />
</template>

<script>
import axios from "axios";
import FieldInput from "@/components/FieldInput.vue";
import OtpSection from "@/components/OtpSection.vue";
import FieldSelect from "@/components/FieldSelect.vue"
import SideCollage from '../components/SideCollage.vue'
import { bannerCode } from '@/store'

export default {
  name: "DaftarPerindo",
  components: {
    FieldInput,
    OtpSection,
    FieldSelect,
    SideCollage
  },

  data() {
    return {
      step: "register",

      otpLogoSrc: require("../assets/images/logo-perindo-new.png"),
      otpIconSrc: require("../assets/icons/otp_icon.png"),

      otpState: "default", // default | error
      otpMessage: "",
      otpLoading: false,
      referenceOptions: [],

      isLoad: false,
      otpValidUntil: "",

      phone: "",
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,

      phoneState: "default",
      phoneMessage: "",
      passwordState: "default",
      passwordMessage: "",
      confirmState: "default",
      confirmMessage: "",
      reference: '',
      referenceOther: '',
      activityID: '',
      banner: null
    };
  },

  computed: {
    stepFromRoute() {
      return this.$route?.query?.step === "otp" ? "otp" : "register";
    },

    canSubmit() {
      let referenceFlag = false
      referenceFlag = !!this.reference
      if(this.reference === 5) {
        referenceFlag = !!this.reference && !!this.referenceOther
      }
      return (
        this.phone.trim().length > 0 &&
        this.password.trim().length > 0 &&
        this.confirmPassword.trim().length > 0 &&
        this.password === this.confirmPassword && referenceFlag
      );
    },

    phoneNumber() {
      return this.$route.query?.number
    }
  },

  watch: {
    stepFromRoute: {
      immediate: true,
      handler(val) {
        if (val === "otp") {
          if (this.otpNumber) this.phone = this.otpNumber;

          if (!this.otpValidUntil) {
            this.otpValidUntil = localStorage.getItem("valid") || "";
          }
        }
      },
    },

    phone(val) {
      if (!val) {
        this.phoneState = "default";
        this.phoneMessage = "";
        return;
      }
      if (val.length < 9) {
        this.phoneState = "error";
        this.phoneMessage = "Nomor terlalu pendek";
      } else {
        this.phoneState = "default";
        this.phoneMessage = "";
      }
    },

    password(val) {
      if (!val) {
        this.passwordState = "default";
        this.passwordMessage = "";
        this.validateConfirm();
        return;
      }

      const hasUpper = /[A-Z]/.test(val);
      if (val.length < 8 || !hasUpper) {
        this.passwordState = "error";
        this.passwordMessage = "Minimal 8 karakter & mengandung huruf besar";
      } else {
        this.passwordState = "success";
        this.passwordMessage = "Minimal 8 karakter dan mengandung huruf besar";
      }

      this.validateConfirm();
    },

    confirmPassword() {
      this.validateConfirm();
    },
  },

  methods: {
    async getReference () {
      try {
        const refs = await axios.get('auth/master-reference')
        this.referenceOptions = refs.data
      } catch (err) {
        this.logger(err)
      }
    },
    showGlobal(message, type = "info") {
      this.$store.commit("showGlobalAlert", { message, type });
    },

    pushOtpQuery() {
      this.$router.push({
        query: {
          ...this.$route.query,
          step: "otp",
          number: this.phone,   // tanpa +62
          type: "daftar",
        },
      });
    },

    backToRegister() {
      this.$router.push({
        query: {
          ...this.$route.query,
          step: undefined,
          number: undefined,
          type: undefined,
        },
      });
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    validateConfirm() {
      if (!this.confirmPassword) {
        this.confirmState = "default";
        this.confirmMessage = "";
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.confirmState = "error";
        this.confirmMessage = "Password tidak sama";
      } else {
        this.confirmState = "default";
        this.confirmMessage = "";
      }
    },

    async requestOtp() {
      if (!this.canSubmit || this.isLoad) return;
      this.isLoad = true;

      try {
        const res = await axios.get(`auth/otp?number=${this.phone}`);

        this.activityID = res?.data?.user_activity_id ?? 0
        localStorage.setItem('referenceID', this.reference)
        localStorage.setItem('referenceOther', this.referenceOther)
        localStorage.setItem("activityID", this.activityID)

        const msg = (res?.data?.error_backend_error?.http_body || "").toString();
        const expired = res?.data?.expired_datetime;

        if(msg.includes('terdaftar')) {
          this.showGlobal(msg, "danger");
          return
        }

        // simpan password (dipakai saat verify, seperti lama)
        this.$cookie.setCookie("password", this.password, { expire: "1D" });

        // simpan expiry
        if (expired) {
          localStorage.setItem("valid", expired);
          this.otpValidUntil = expired;
        } else {
          // fallback kalau backend ga ngirim expired
          this.otpValidUntil = localStorage.getItem("valid") || "";
        }

        // message "Mohon menunggu" tetap lanjut otp
        this.pushOtpQuery();

      } catch (err) {
        const message = err?.response?.data || "Terjadi kesalahan";

        if (message.includes("Mohon menunggu")) {
          this.$cookie.setCookie("password", this.password, { expire: "1D" });
          this.otpValidUntil = localStorage.getItem("valid") || "";
          this.pushOtpQuery();
          return;
        }

        this.showGlobal(message, "danger");
      } finally {
        this.isLoad = false;
      }
    },

    onSubmit() {
      this.requestOtp();
    },

    async verifyOtp(code) {
      if (this.otpLoading) return;

      this.otpLoading = true;
      this.otpState = "default";
      this.otpMessage = "";

      try {
        const pass = this.$cookie.getCookie("password") || "";

        const form = {
          number: this.$route?.query?.number,
          otp: code,
          password: pass,
          reference_id: this.reference || localStorage.getItem('referenceID'),
          reference_other: this.referenceOther || localStorage.getItem('referenceOther'),
          user_activity_id: this.activityID || localStorage.getItem('activityID')
        };

        const encoded = Object.keys(form)
          .map((k) => `${k}=${encodeURIComponent(form[k] ?? "")}`)
          .join("&");

        if (this.otpType !== "forgotPassword") {
          const verOtp = await axios.post("auth/verifyotp", encoded, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          });

          if (verOtp?.data?.token) {
            this.showGlobal("Sukses Register Akun :)", "success");

            // bersihkan storage/cookie
            localStorage.removeItem("valid");
            this.$cookie.removeCookie("password");

            // simpan token
            await this.$cookie.setCookie("token", verOtp.data.token);

            // redirect dashboard
            this.$router.push("/dashboard");
            return;
          }

          // kalau ga ada token
          this.otpState = "error";
          this.otpMessage = "OTP tidak valid";
          this.showGlobal("OTP tidak valid", "danger");
        } else {
          // === forgot password ===
          const verOtp = await axios.patch("auth/verifyforgotpassword", encoded, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          });

          if (verOtp?.status < 300) {
            this.showGlobal("Sukses Forgot Password :)", "success");
            this.$cookie.removeCookie("password");
            this.$router.push("/login");
            return;
          }

          this.otpState = "error";
          this.otpMessage = "";
          this.showGlobal("OTP tidak valid", "danger");
        }
      } catch (err) {
        const message = err?.response?.data?.message || "OTP yang kamu masukkan salah";

        // set error state agar OtpSection jadi merah + shake
        this.otpState = "error";
        this.otpMessage = message;

        this.showGlobal(message, "danger");
      } finally {
        this.otpLoading = false;
      }
    },

    async resendOtp() {
      try {
        const res = await axios.get(`auth/otp?number=${this.otpNumber || this.phoneNumber}`);

        // refresh expired time kalau ada
        const valid = localStorage.getItem("valid");
        if (valid) this.otpValidUntil = valid;

        const errMes = res.data?.error_backend_error?.http_body

        if(errMes.includes('terdaftar')) {
          this.showGlobal(errMes, "danger");
        } else {
          this.showGlobal("Kode OTP sudah dikirimkan ulang", "info");
        }

        this.otpState = "default";
        this.otpMessage = "";
      } catch (err) {
        const message = err?.response?.data?.message || "Gagal kirim ulang OTP";
        this.showGlobal(message, "danger");
      }
    },

    onOtpChange() {
      if (this.otpState === "error") {
        this.otpState = "default";
        this.otpMessage = "";
      }
    },

    onLogin() {
      this.$router.push({ name: "Login" });
    },
  },
  async mounted () {
    this.getReference()
    const res = await this.$store.dispatch('getBanners', bannerCode.bnrRgstHtml)
    this.banner = res?.data
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-color: white;
}

.layout {
  height: 100vh;
  display: flex;
  gap: 24px;
  padding: 18px;
  margin: 0 auto;
}

/* LEFT */
.left {
  overflow-y: auto;
  min-height: calc(100vh - 20px);
  background: #ffffff;
  position: relative;
  padding: 20px 18px;
  display: flex;
  width: 50%;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

.topbar {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
}

.topbar__logo {
  height: 32px;
  width: auto;
  object-fit: contain;
}

.formWrap {
  padding: 56px 0 0;
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-self: center;
  flex-direction: column;
  gap: 10px;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #374151;
}

.subtitle {
  margin: 6px 0 22px;
  color: #6b7280;
  font-size: 13px;
}

.title,
.subtitle {
  text-align: center;
}

/* form layout */
.form {
  display: grid;
  gap: 14px;
}

.phoneRow {
  display: flex;
}

/* hint under field (icon + text) */
.hint {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: -6px;
  color: #6b7280;
  font-size: 13px;
}

/* Eye button inside FieldInput slot icon */
.eye {
  border: none;
  background: transparent;
  padding: 0;
  display: grid;
  place-items: center;
  width: 34px;
  height: 28px;
  cursor: pointer;
  opacity: 0.75;
}

.eye:hover {
  opacity: 1;
}

.eye img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* Button submit */
.btn {
  margin-top: 10px;
  height: 50px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #eef2f7;
  color: #9ca3af;
  font-weight: 800;
  cursor: not-allowed;
}

.btn:not(:disabled) {
  background: #223f80;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(34, 63, 128, 0.18);
}

.signup {
  margin: 6px 0 0;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}

.signup a {
  color: #223f80;
  font-weight: 800;
  text-decoration: none;
  margin-left: 4px;
}

.signup a:hover {
  text-decoration: underline;
}

/* info box */
.info {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
}

.info__icon {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  background: #111827;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.info__icon img {
  width: 44px;
  height: 44px;
  object-fit: cover;
}

.info__text {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.35;
  color: #4b5563;
}

.info__text strong {
  color: #374151;
}

.footer {
  padding-top: 18px;
  color: #9ca3af;
  font-size: 12px;
  align-self: flex-start;
}

/* RIGHT */
.right {
  width: 50%;
  display: grid;
  align-items: stretch;
}

.hero {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #0b1b4a;
}

.hero__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(10, 30, 90, 0.15) 0%,
    rgba(10, 30, 90, 0.55) 55%,
    rgba(10, 30, 90) 100%
  );
}

.hero__content {
  position: absolute;
  left: 28px;
  right: 28px;
  bottom: 28px;
  color: #ffffff;
}

.quote {
  margin: 0 0 18px;
  font-size: 15px;
  line-height: 1.45;
  max-width: 520px;
  margin-bottom: 2rem;
}

.author__name {
  font-size: 22px;
  font-weight: 900;
  margin-bottom: 4px;
}

.author__role {
  font-size: 13px;
  opacity: 0.9;
}

/* RESPONSIVE (mobile) */
@media (max-width: 980px) {
  .layout {
    grid-template-columns: 1fr;
    gap: 0;
    padding: 0;
    max-width: 520px;
  }

  .left {
    border-radius: 0;
    border: none;
    min-height: 100vh;
    padding: 18px 16px;
    width: 100%;
  }

  .right {
    display: none;
  }

  .formWrap {
    padding-top: 52px;
    margin-top: 0;
  }
}
</style>
